import api from '@/libs/axios'

export default {
  getSuppliers: () => api.get('/system/supplier/'),
  getSupplierById: id => api.get(`/system/supplier/${id}`),
  editSupplier: form => api.patch(`/system/supplier/${form.id}`, form),
  createSupplier: form => api.post('/system/supplier', form),
  deleteSuppliers: array => api.delete('/system/supplier', array),
}
